import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: '#81D8D0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Georgia', 'Noto Serif TC', serif",
      }}
    >
      <div
        style={{
          textAlign: 'center',
          opacity: 0,
          animation: 'welcomeFadeIn 2s ease forwards',
        }}
      >
        <p
          style={{
            color: '#fff',
            fontSize: '1.1rem',
            letterSpacing: '0.15em',
            marginBottom: '1rem',
          }}
        >
          我是 Felicity。
        </p>
        <div
          style={{
            color: 'rgba(255,255,255,0.75)',
            fontSize: '0.85rem',
            letterSpacing: '0.08em',
            marginBottom: '2.5rem',
            lineHeight: 1.6,
          }}
        >
          如果你是
          <br />
          felicity19990819@gmail.com 的主人
        </div>
        <button
          onClick={() => navigate('/login')}
          style={{
            display: 'inline-block',
            background: '#fff',
            color: '#81D8D0',
            fontFamily: "'Georgia', 'Noto Serif TC', serif",
            fontSize: '1.05rem',
            fontWeight: 600,
            letterSpacing: '0.12em',
            padding: '16px 48px',
            borderRadius: '50px',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
          }}
        >
          按 此 進 入
        </button>
      </div>

      <style>{`
        @keyframes welcomeFadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
